module.exports = __webpack_public_path__ + "img/Social Networker.d7439c97.svg";